import { createContext } from 'react';
const LanguageContext = createContext({
  currentLang: '',
  staticData: {},
});

export default LanguageContext;
